import { ChevronLeft } from '@ifood/pomodoro-icons';
import { FormattedMessage } from 'gatsby-plugin-intl';
import * as React from 'react';

import { OnBack } from './styles';

type PropTypes = {
  onBackClick?: () => void;
};

export const BackButton = ({ onBackClick }: PropTypes): JSX.Element => (
  <OnBack variant="tertiary" onClick={onBackClick}>
    <ChevronLeft />
    <FormattedMessage id="back-button.back" />
  </OnBack>
);
